import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Footer } from '@components/Layout'
import { Seo } from '@components/Seo'
import { useLang, withLang } from '@shared/i18n/useLang'

export function InDevelopmentPage() {
  const { t } = useTranslation()
  const lang = useLang()

  return (
    <>
      <Seo title={t('inDevelopment.title')} description={t('inDevelopment.text')} noindex />

      <section style={{
        flex: 1,
        background: '#171C22',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 32px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* crosshatch */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.02) 0 2px, transparent 2px 26px)',
          pointerEvents: 'none',
        }} />

        <div style={{
          position: 'relative',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', gap: 24,
          textAlign: 'center', maxWidth: 640,
        }}>
          {/* kicker */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ width: 8, height: 8, background: '#189BD5', flexShrink: 0 }} />
            <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '.16em', textTransform: 'uppercase', color: '#93A3AE' }}>
              {t('inDevelopment.kicker')}
            </span>
            <span style={{ width: 8, height: 8, background: '#189BD5', flexShrink: 0 }} />
          </div>

          {/* big code */}
          <div className="error-code" style={{
            fontWeight: 800,
            letterSpacing: '-.03em', lineHeight: 1,
            color: '#FFFFFF',
            textShadow: '6px 6px 0 rgba(24,155,213,.35)',
          }}>
            ···
          </div>

          <h1 className="wip-h1" style={{ margin: 0, fontSize: 28, fontWeight: 700, letterSpacing: '-.01em', color: '#FFFFFF' }}>
            {t('inDevelopment.title')}
          </h1>

          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.7, color: '#93A3AE' }}>
            {t('inDevelopment.text')}
          </p>

          <div className="wip-actions" style={{ display: 'flex', gap: 12, marginTop: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link
              to={withLang(lang, '/')}
              style={{ background: '#189BD5', color: '#FFFFFF', fontSize: 12, fontWeight: 600, letterSpacing: '.08em', textTransform: 'uppercase', padding: '14px 28px', borderRadius: 3, transition: 'background .15s' }}
            >
              {t('common.toHome')}
            </Link>
            <Link
              to={withLang(lang, '/zayavka')}
              style={{ border: '1px solid #3A434D', color: '#E7EBEE', fontSize: 12, fontWeight: 600, letterSpacing: '.08em', textTransform: 'uppercase', padding: '14px 28px', borderRadius: 3, transition: 'border-color .15s' }}
            >
              {t('inDevelopment.secondLink')}
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
